import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box } from '@mafc/trolly';

import CartCheckoutContainer from 'common/CartCheckoutContainer';
import useLayoutWidth from '../hooks/useLayoutWidth';

interface CartLayoutProps {
  children?: React.ReactNode;
  t: any;
}

const CartLayout: React.FC<CartLayoutProps> = ({ children, t }) => {
  const desktopWidth = useLayoutWidth();
  return (
    <Box width={[1, 1, 1, desktopWidth]} mr={[0, 0, 4]}>
      <CartCheckoutContainer.Title>{t('myShoppingCart')}</CartCheckoutContainer.Title>
      {children}
    </Box>
  );
};
export default withTranslation()(CartLayout);
